import { createStore } from '@direct-frontend/modules-store';

export const loadingStore = createStore('entities/order');
